import React from 'react'

const Logo = () => (
  <svg viewBox="0 0 304 116.492" height={116.492 * 0.3} width={304 * 0.3}>
    <defs>
      <linearGradient
        id="E"
        gradientTransform="matrix(0 -21.71478 -21.71478 0 1209.199 115.597)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.552} stopColor="#fff" />
        <stop offset={0.691} stopColor="#efeeee" />
        <stop offset={0.8} stopColor="#e9e9e9" />
        <stop offset={1} stopColor="#d3d2d2" />
      </linearGradient>
      <linearGradient
        id="D"
        gradientTransform="matrix(0 -15.65387 -15.65387 0 1221.655 109.639)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.552} stopColor="#fff" />
        <stop offset={0.691} stopColor="#efeeee" />
        <stop offset={0.8} stopColor="#e9e9e9" />
        <stop offset={1} stopColor="#d3d2d2" />
      </linearGradient>
      <linearGradient
        id="C"
        gradientTransform="matrix(0 -31.5641 -31.5641 0 1215.194 119.73)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.552} stopColor="#fff" />
        <stop offset={0.691} stopColor="#fafafa" />
        <stop offset={0.8} stopColor="#d3d2d2" />
        <stop offset={1} stopColor="#bdbcbc" />
      </linearGradient>
      <linearGradient
        id="B"
        gradientTransform="scale(-36.612 36.612) rotate(75 -18.603 -20.54)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#b2b1b1" />
        <stop offset={0.35} stopColor="#deddde" />
        <stop offset={0.65} stopColor="#deddde" />
        <stop offset={1} stopColor="#b2b1b1" />
      </linearGradient>
      <linearGradient
        id="A"
        gradientTransform="scale(-36.78255 36.78255) rotate(75 -17.832 -20.265)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#b2b1b1" />
        <stop offset={0.35} stopColor="#deddde" />
        <stop offset={0.65} stopColor="#deddde" />
        <stop offset={1} stopColor="#b2b1b1" />
      </linearGradient>
      <clipPath id="z">
        <path d="M1163.689 62.096h102.93v67.565h-102.93V62.096z" />
      </clipPath>
      <linearGradient
        id="y"
        gradientTransform="matrix(0 22.01262 22.01262 0 1200.232 93.443)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="x"
        gradientTransform="matrix(0 22.0118 22.0118 0 1212.298 93.444)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="w"
        gradientTransform="matrix(0 20.79395 20.79395 0 1211.591 94.198)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="v"
        gradientTransform="matrix(0 22.00942 22.00942 0 1217.303 93.445)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="u"
        gradientTransform="matrix(0 21.54384 21.54384 0 1227.17 93.855)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="t"
        gradientTransform="matrix(0 22.02289 22.02289 0 1202.325 93.439)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="s"
        gradientTransform="matrix(0 22.01186 22.01186 0 1201.802 93.444)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="r"
        gradientTransform="matrix(0 22.00638 22.00638 0 1204.674 93.448)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="q"
        gradientTransform="matrix(0 22.0111 22.0111 0 1194.82 93.445)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="p"
        gradientTransform="matrix(0 21.86404 21.86404 0 1211.42 93.449)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="o"
        gradientTransform="matrix(0 21.50403 21.50403 0 1214.862 93.69)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="n"
        gradientTransform="matrix(0 22.01205 22.01205 0 1236.116 93.444)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="m"
        gradientTransform="matrix(0 22.03143 22.03143 0 1224.112 93.436)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="l"
        gradientTransform="matrix(0 22.01746 22.01746 0 1231.576 93.443)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="k"
        gradientTransform="matrix(0 21.85729 21.85729 0 1219.94 93.451)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="j"
        gradientTransform="matrix(0 22.00777 22.00777 0 1210.422 93.445)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="i"
        gradientTransform="matrix(0 22.01242 22.01242 0 1229.472 93.443)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="h"
        gradientTransform="matrix(0 20.87723 20.87723 0 1220.735 93.998)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="g"
        gradientTransform="matrix(0 20.19708 20.19708 0 1232.885 94.284)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="f"
        gradientTransform="matrix(0 22.04788 22.04788 0 1231.536 93.432)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="e"
        gradientTransform="matrix(0 21.75793 21.75793 0 1222.232 93.516)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="d"
        gradientTransform="matrix(0 31.40509 31.40509 0 1215.638 88.12)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <linearGradient
        id="c"
        gradientTransform="matrix(0 31.40224 31.40224 0 1215.13 88.122)"
        gradientUnits="userSpaceOnUse"
        x2={1}
      >
        <stop offset={0} stopColor="#08142e" />
        <stop offset={0.809} stopColor="#17326e" />
        <stop offset={1} stopColor="#0d69a9" />
      </linearGradient>
      <radialGradient
        id="b"
        spreadMethod="pad"
        gradientTransform="matrix(177.90231 0 0 -173.47302 1214.898 -51.051)"
        gradientUnits="userSpaceOnUse"
        r={1}
        cy={0}
        cx={0}
        fy={0}
        fx={0}
      >
        <stop offset={0} stopColor="#00050d" />
        <stop offset={0.7} stopColor="#051125" />
        <stop offset={0.904} stopColor="#173e7e" />
        <stop offset={0.955} stopColor="#4ca9e3" />
        <stop offset={1} stopColor="#4ca9e3" />
      </radialGradient>
      <clipPath id="a">
        <path d="M1163.689 62.096h102.93v67.565h-102.93V62.096z" />
      </clipPath>
    </defs>
    <g>
      <g
        clipPath="url(#a)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      >
        <path
          d="M1256.149 105.104a5.88 5.88 0 0 0 .039-.225c-.01.075-.025.15-.04.225m-40.95 14.257c-22.871 0-41.203-6.855-41.203-15.45 0-8.542 18.484-15.45 41.203-15.45 22.72 0 41.203 6.93 41.203 15.45 0 8.519-18.483 15.45-41.203 15.45"
          fill="#d3d2d2"
        />
      </g>
      <path
        d="M1174.628 103.919c0-8.195 18.155-14.823 40.57-14.823 22.417 0 40.57 6.628 40.57 14.823 0 8.199-18.153 14.824-40.57 14.824-22.415 0-40.57-6.625-40.57-14.824"
        fill="url(#b)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1177.682 103.915c0-.555.112-1.103.327-1.64-.093.354-.141.71-.141 1.073 0 6.786 16.796 12.286 37.514 12.286 19.059 0 34.795-4.655 37.196-10.681-1.601 6.34-17.724 11.322-37.383 11.322-20.719 0-37.513-5.533-37.513-12.36"
        fill="url(#c)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1254.073 103.915c0-7.474-17.406-13.532-38.878-13.532-19.109 0-34.996 4.798-38.265 11.119 2.487-6.583 18.795-11.665 38.543-11.665 21.47 0 38.873 6.005 38.873 13.417 0 .752-.179 1.491-.525 2.208a4.928 4.928 0 0 0 .252-1.547"
        fill="url(#d)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1222.438 102.605c-.871-.907-.935-2.08-.365-2.608.203-.189.438-.276.689-.291-.373.472-.548 1.396-.086 2.127-.085.216-.102.46-.052.703.012.058-.035.113-.096.113a.128.128 0 0 1-.09-.044"
        fill="url(#e)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1231.419 100.67c.013-.136.048-.394.078-.586.045.085.089.178.137.275.036.073.018.096-.014.108-.09.032-.181.1-.193.17-.01.013-.01.026-.01.041v-.008z"
        fill="url(#f)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1232.485 103.639c.291-.277.468-.616.502-.926.013-.147.125-.165.216-.036l.083.129a3.17 3.17 0 0 1-.079.103c-.127.15-.429.475-.722.73z"
        fill="url(#g)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1220.425 104.211c.233-.318.343-.774.327-1.357 0-.151.106-.141.178-.039.04.057.077.11.115.161-.17.525-.433 1.041-.62 1.235z"
        fill="url(#h)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1228.463 101.163c-.812-.999-1.25-2.014-1.266-3.004-.01-.35.128-.784.438-.945a1.01 1.01 0 0 1 .311-.108 1.706 1.706 0 0 0-.056.398c-.011 1.019.306 2.041 1.118 3.038.985 1.214 2.02 1.818 2.739 1.485a.788.788 0 0 1-.48.64.982.982 0 0 1-.432.095c-.685 0-1.563-.605-2.372-1.599"
        fill="url(#i)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1212.153 103.278c-1.103-.419-2.208-1.069-2.973-2.092-.866-1.162-1.101-2.562-.52-3.367.137-.189.302-.328.485-.42-.314.963-.087 2.254.649 3.247.757 1.027 1.61 1.414 2.582 1.835.126.056.143.129.118.242a11.56 11.56 0 0 1-.217.79l-.001.001c.031-.107 0-.188-.123-.236"
        fill="url(#j)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1220.395 100.183c-1.027-1.57-1.987-3.088-3.005-4.682-.053-.075-.1-.123-.205-.128-.631 0-1.319.002-2.014-.002-.073 0-.123.033-.14.084.055-.244.144-.685.168-.787.017-.07.069-.106.147-.106.746 0 1.661 0 2.282.003.092.005.157.058.205.128.926 1.45 1.916 3.025 2.862 4.479.209-.732.314-1.075.701-1.419.393-.353.755-.443 1.291-.449.487-.005.966.189 1.533.426.206.085.388.19.552.295 0 .27.027.539.075.798 0 .028-.023.206-.176.1a4.366 4.366 0 0 0-1.032-.555c-.523-.195-.769-.269-1.254-.263-.611.004-1.162.263-1.55.868-.216.327-.306.825-.327 1.19 0 .026-.024.065-.055.065-.017 0-.038-.012-.058-.045"
        fill="url(#k)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1238.081 99.375c-.98-1.198-2.065-2.33-3.102-3.13-1.615-1.25-3.226-1.567-4.023-.767a1.737 1.737 0 0 0-.48 1.086c-.01.195-.109.205-.202.114-.952-.941-2.607-1.985-4.113-1.243-.755.373-1.16 1.064-1.316 1.829.094-.562.216-1.345.474-1.833.173-.33.557-.701.793-.818 1.336-.659 3.244.089 4.469 1.267l.033.037.134-.504c.084-.274.214-.522.33-.654.838-.948 2.619-.517 4.471.916 1.034.801 1.802 1.605 2.742 2.699.037.046.034.113.014.214-.054.237-.14.67-.186.886a.153.153 0 0 0-.038-.099m-13.249-2.044c0-.022.01-.045.013-.067 0 .013-.01.027-.01.04 0 .009 0 .018-.01.027z"
        fill="url(#l)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1225.31 102.675c-.094-.598-.417-1.124-.967-1.396-.465-.227-1.009-.188-1.39.152a1.109 1.109 0 0 0-.266.377c.099-.45.183-.782.301-.959.36-.54.981-.678 1.667-.307.496.269.933.838.877 1.762-.028.46-.162.932-.376 1.316a1.53 1.53 0 0 0 .154-.945"
        fill="url(#m)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1239.403 108.343c-.313-.543-6.347-9.73-6.728-10.68-.121-.301-.136-.53-.013-.697.125-.167.307-.231.513-.227.019.115.064.247.12.385.382.953 6.033 9.541 6.343 10.085.026.047.018.1.01.134l-.225 1.085c0-.025 0-.054-.018-.085"
        fill="url(#n)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1214.353 104.067c.018-.019.032-.039.048-.059.363-.54.561-1.301.58-2.087.023-.165.094-.169.175-.083.073.074.145.152.215.229-.105.423-.271.802-.44 1.167-.063.134-.341.608-.578.833z"
        fill="url(#o)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1217.431 102.248c-1.302-.985-2.396-2.522-2.949-3.208-.328-.405-.636-1.001-1.489-1.927-1.343-1.457-3.121-2.294-4.836-1.716a2.91 2.91 0 0 0-1.873 1.992c-.052.179-.152.229-.248.111-.278-.345-.844-.854-1.318-1.175-.051-.037-.179-.112-.289-.058-.099.044-.451.542-.521.684a.11.11 0 0 0-.016.046v-.005c.123-.612.139-.682.305-.964.191-.313.375-.532.416-.551.111-.055.223-.004.279.026.367.189 1.085.74 1.393 1.125.094.088.183.028.214-.065.128-.41.318-.725.529-1.06.231-.372.695-.759 1.295-.925.777-.217 1.615-.256 2.717.166.883.338 1.809 1.027 2.522 1.8.854.927 1.163 1.523 1.487 1.929.554.685 1.416 1.899 2.626 2.932.423.361.886.595 1.177.482.175.45.092.698-.095.819a.394.394 0 0 1-.222.059c-.304 0-.732-.232-1.104-.517"
        fill="url(#p)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1195.766 103.478c-.732-.374-1.613-1.014-2.047-1.887-.354-.714-.425-1.572.114-2.391a2.09 2.09 0 0 1 .147-.193c-.172.68.014 1.41.288 1.959.433.874 1.042 1.29 1.642 1.669.257.163.372.321.219.748-.044.121-.069.339-.116.534a.439.439 0 0 0-.247-.439"
        fill="url(#q)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1201.301 112.26c-2.116-.791-3.043-2.468-2.597-3.589.086-.215.223-.38.4-.499-.149 1.035.626 2.729 2.66 3.401 2.661.878 5.627.323 8.012-.187.333.209.626.353.917.512.146.075-.018.166-.062.166-1.909.359-3.865.783-5.806.783-1.185 0-2.365-.158-3.524-.587"
        fill="url(#r)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1210.164 105.965c-.957-.055-2.452-.2-3.464-.326-.246-.03-.282-.076-.332-.162-1.614-2.661-3.337-5.531-5.23-7.453-2.028-2.06-3.716-2.602-5.507-2.617-2.067-.014-3.908 1.159-4.371 3.217.248-1.149.99-2.535 1.847-3.138.871-.615 1.729-.819 2.732-.837 2.037-.036 3.897.804 5.868 2.807 1.893 1.921 3.532 4.605 5.147 7.266.055.095.111.136.383.17 1.013.127 1.922.184 2.817.269.267.025.47.049.567-.048.324-.323.7-.619.949-.763.166-.002.304-.039.402-.126.104.014.2.072.261.131.116.113.122.247.102.361-.04.22-.099.656-.17.782.048-.096.018-.233-.08-.341a.419.419 0 0 0-.323-.155c-.115.003-.185.042-.331.122-.3.162-.675.429-.925.744-.065.081-.106.102-.217.102-.034 0-.074-.002-.125-.005"
        fill="url(#s)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1201.423 104.355c-.223-.162-.543-.14-.684.075a.436.436 0 0 0-.072.232c-.02-.345.117-.852.23-1.023.122-.188.467-.28.742-.078.616.456 1.174.72 1.798.839.161.219.335.462.533.735.016.022.02.051.013.065-.012.023-.03.031-.07.033-.915-.025-1.714-.298-2.49-.878"
        fill="url(#t)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1227.152 112.829a.41.41 0 0 1 0 0z"
        fill="url(#u)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1227.248 112.435c-.033-.589-.49-1.156-1.615-1.77-1.278-.702-2.616-.914-4.013-.926-3.381-.028-6.529 1.289-9.787 1.997 0-.142.041-.313-.078-.402-1.804-1.331-3.436-2.683-4.528-4.581-.037-.045-.017-.087.046-.082l.842.042c.995 1.558 2.059 2.452 3.687 3.653.121.091.242.156.203.502 3.266-.724 5.752-1.927 9.972-1.939 1.259-.003 3.035.417 3.989.993 1.098.66 1.39 1.145 1.431 1.658.012.16-.029.399-.056.522-.037.174-.062.395-.112.56a.69.69 0 0 0 .019-.227"
        fill="url(#v)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1211.515 108.463c-.04-.039-.085-.078-.13-.118a1.365 1.365 0 0 1-.373-1.111c.025-.137.078-.163.14-.151.062.013.124.033.187.058a.813.813 0 0 0 .287.528.554.554 0 0 0 .447.149c.124.249.16.545.01.675a.355.355 0 0 1-.237.084.588.588 0 0 1-.33-.114"
        fill="url(#w)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1212.815 107.306c-.31-.593-.821-.91-1.312-1.064 0 0-.103-.022-.088-.116.013-.106.36-.327.578-.48a1.708 1.708 0 0 1 .993.913c.155.341.239.61.172 1.197-.048.411-.131.783-.241.974.211-.43.126-.983-.102-1.424"
        fill="url(#x)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1203.791 110.076c.063-.15.063-.372-.056-.653-.895-2.102-2.603-3.768-4.684-3.839-1.254-.041-2.193.602-2.632 1.551.322-.709.981-1.341 1.557-1.703.451-.282 1.008-.437 1.644-.416 2.168.073 3.81 1.859 4.354 3.369.146.407.032.844-.036 1.138-.027.113-.065.37-.147.553z"
        fill="url(#y)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <g
        clipPath="url(#z)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      >
        <path
          d="M1256.149 105.104a5.88 5.88 0 0 0 .039-.225c-.01.075-.025.15-.04.225m-81.87-1.363c-.008 1.807.789 3.605 2.464 5.295 5.898 5.95 21.354 9.972 38.386 10.042 22.565.094 40.952-6.634 40.99-14.997.009-1.808-.836-3.582-2.512-5.271-5.9-5.952-21.306-9.996-38.338-10.067-22.564-.094-40.952 6.634-40.99 14.998m40.92 15.62c-22.871 0-41.203-6.855-41.203-15.45 0-8.542 18.484-15.45 41.203-15.45 22.72 0 41.203 6.93 41.203 15.45 0 8.519-18.483 15.45-41.203 15.45"
          fill="#4f4c4d"
        />
      </g>
      <path
        d="M1174.119 103.91c0-.403.047-.802.13-1.197a5.888 5.888 0 0 0-.1 1.027c-.01 1.833.812 3.682 2.501 5.387 5.931 5.983 21.402 10.009 38.478 10.08 2.366.01 4.684-.057 6.942-.191a109.25 109.25 0 0 1-6.872.215c-22.778 0-41.079-6.829-41.079-15.321"
        fill="url(#A)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1256.247 104.077c.01-1.832-.86-3.658-2.55-5.361-5.91-5.963-21.376-10.031-38.429-10.102-2.411-.01-4.776.055-7.074.194 2.275-.145 4.616-.218 7.004-.218 22.648 0 41.074 6.914 41.074 15.317 0 .32-.03.639-.082.955.037-.26.056-.521.057-.785"
        fill="url(#B)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1176.314 103.915c0-7.474 17.408-13.532 38.881-13.532 21.472 0 38.878 6.058 38.878 13.532s-17.406 13.531-38.878 13.531c-21.473 0-38.881-6.057-38.881-13.531m1.368 0c0 6.827 16.794 12.36 37.513 12.36 20.719 0 37.512-5.533 37.512-12.36 0-6.827-16.793-12.362-37.512-12.362s-37.513 5.535-37.513 12.362"
        fill="url(#C)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1237.199 108.504c-.154 0-.233-.019-.306-.161-.239-.458-3.149-4.819-3.69-5.666-.091-.129-.203-.111-.216.036-.055.503-.489 1.08-1.174 1.358a2.99 2.99 0 0 1-1.561.18c-.957-.129-1.81-.634-2.559-1.204-1.131-.858-2.105-1.972-3.364-2.794-.686-.448-1.628-.839-2.256-.256-.57.528-.506 1.701.365 2.608.092.096.203.017.186-.069-.083-.411.019-.819.329-1.105.381-.34.925-.379 1.39-.152.55.272.873.798.967 1.396.146.925-.567 1.742-1.459 1.807-.724.051-1.419-.201-2.096-.76a3.987 3.987 0 0 1-.825-.907c-.072-.102-.182-.112-.178.039.034 1.186-.456 1.852-1.437 1.875-.76.018-1.574-.396-2.207-.9-.694-.558-1.302-1.296-1.952-1.991-.081-.086-.152-.082-.175.083-.019.786-.217 1.547-.58 2.087a.483.483 0 0 1-.627.154c-.105-.057-.471-.225-.737-.44-.131-.109-.183-.266-.125-.468a5.477 5.477 0 0 0-.202-3.633c-.437-1.032-1.287-1.964-2.285-2.278-.658-.209-1.342-.107-1.765.476-.581.805-.346 2.205.52 3.367.765 1.023 1.87 1.673 2.973 2.092.13.05.157.134.12.244-.06.181-.156.428-.194.541-.101.269-.385.313-.731.275-.801-.093-1.524-.368-2.239-.75-1.87-1.001-2.807-2.94-3.218-3.976-.198-.499-.367-.809-.586-1.085-.294-.371-.665-.708-1.342-1.303a.238.238 0 0 1-.055-.273c.07-.142.422-.64.521-.684.11-.054.238.021.289.058.474.321 1.04.83 1.318 1.175.096.118.196.068.248-.111a2.91 2.91 0 0 1 1.873-1.992c1.715-.578 3.493.259 4.836 1.716.853.926 1.161 1.522 1.489 1.927.553.686 1.647 2.223 2.949 3.208.477.365 1.043.642 1.326.458.228-.148.303-.492-.064-1.157-1.327-2.425-3.28-5.272-3.639-5.964-.066-.119-.01-.214.117-.214.695.004 1.383.002 2.014.002.105.005.152.053.205.128 1.018 1.594 1.978 3.112 3.005 4.682.058.091.11.02.113-.02.021-.365.111-.863.327-1.19.388-.605.939-.864 1.55-.868.485-.006.731.068 1.254.263.427.159.77.366 1.032.555.153.106.18-.072.176-.1-.236-1.266.056-2.766 1.314-3.388 1.506-.742 3.161.302 4.113 1.243.093.091.192.081.202-.114.019-.359.183-.787.48-1.086.797-.8 2.408-.483 4.023.767 1.037.8 2.122 1.932 3.102 3.13.037.046.064.121-.01.197-.149.155-.365.334-.513.472-.067.057-.166.041-.224-.003-1.004-.955-1.909-2.044-3.217-2.946-.44-.308-1.143-.556-1.459-.129-.123.167-.108.396.013.697.381.95 6.415 10.137 6.728 10.68.055.094 0 .163-.121.163l-2.083-.002m-9.564-11.29c-.31.161-.445.595-.438.945.016.99.454 2.005 1.266 3.004.991 1.217 2.085 1.851 2.804 1.504.743-.354.505-1.215.173-1.89a.19.19 0 0 1-.013-.14c.012-.07.103-.138.193-.17.032-.012.05-.035.014-.108-.256-.55-.493-.868-.814-1.345a5.016 5.016 0 0 0-1.033-1.117c-.47-.388-1.08-.804-1.655-.804-.17 0-.338.036-.497.121"
        fill="url(#D)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
      <path
        d="M1205.123 114.076c-.576 0-1.154-.022-1.737-.069-3.709-.313-7.237-2.401-7.245-5.57 0-1.608 1.14-2.91 2.91-2.853 2.081.071 3.789 1.737 4.684 3.839.339.797-.29 1.128-.589.669a5.295 5.295 0 0 0-2.1-1.867c-.979-.48-2.025-.35-2.342.446-.446 1.121.481 2.798 2.597 3.589 3.056 1.131 6.254.382 9.33-.196.044 0 .208-.091.062-.166-.55-.3-1.092-.545-1.937-1.272-.607-.519-1.4-1.209-2.014-1.962-.608-.742-1.04-1.404-1.611-2.136-.08-.107-.178-.102-.176-.102-1.392-.235-2.756-.392-4.003-1.26-.258-.178-.37-.494-.213-.736.141-.215.461-.237.684-.075.776.58 1.575.853 2.49.878.04-.002.058-.01.07-.033.01-.014 0-.043-.013-.065-1.372-1.902-1.715-2.332-2.746-3.511a20.29 20.29 0 0 0-1.627-1.65c-2.341-2.175-4.861-2.139-5.764-.774-.539.819-.468 1.677-.114 2.391.434.873 1.315 1.513 2.047 1.887.272.139.35.486.078.802-.172.207-.593.244-.904.187-.96-.178-2.093-.903-2.763-1.775a4.865 4.865 0 0 1-1.005-3.502c.227-2.408 2.209-3.799 4.459-3.783 1.791.015 3.479.557 5.507 2.617 1.893 1.922 3.616 4.792 5.23 7.453.05.086.086.132.332.162 1.012.126 2.507.271 3.464.326.214.012.257.009.342-.097.25-.315.625-.582.925-.744.146-.08.216-.119.331-.122a.419.419 0 0 1 .323.155c.102.112.13.256.076.351-.057.098-.726.469-.746.618-.015.094.088.116.088.116.491.154 1.002.471 1.312 1.064.304.584.353 1.364-.204 1.797-.488.38-1.226.32-1.815-.208-.575-.513-.767-1.26-.688-1.914.013-.113.01-.152-.147-.165-.886-.07-1.739-.095-2.688-.145-.063-.005-.083.037-.046.082 1.092 1.898 2.724 3.25 4.528 4.581.119.089.083.26.078.402 3.258-.708 6.406-2.025 9.787-1.997 1.397.012 2.735.224 4.013.926 1.125.614 1.582 1.181 1.615 1.77.027.408-.256.665-.66.578-3.415-.785-6.672-.776-10.071-.365-3.854.467-7.553 1.428-11.388 1.428h-.01m5.889-6.842a1.37 1.37 0 0 0 .454 1.186c.193.172.455.211.616.073.18-.154.095-.537-.087-.803-.198-.293-.536-.546-.843-.607a.12.12 0 0 0-.025-.003c-.051 0-.093.036-.115.154"
        fill="url(#E)"
        transform="matrix(3.64051 0 0 -3.64051 -4271.941 436.535)"
      />
    </g>
  </svg>
)

export default Logo



// WEBPACK FOOTER //
// ./src/app/Auto/components/logos/FordLogo.js